import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { http } from "../../service/http";

//pHaniver - TODO - delete toggle and menu related code when reference 0
export const fetchDashboard = createAsyncThunk("app/fetchDashboard", async (data, extra) => {
  // extra.dispatch(setShowMainLoader(true));
  const res = await http.get("/user_profile/backend/dashboard", {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  if (res.data.status === "success") {
    // extra.dispatch(setShowMainLoader(false));
    return res.data.data;
  } else {
    // extra.dispatch(setShowMainLoader(false));
  }
});

//Global Search Functionality
export const fetchGlobalSearchData = createAsyncThunk("app/globalSearch", async (data, extra) => {
  const res = await http.get(`/user_profile/backend/global_search?query=${data}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  if (res.data.status === "success") {
    return res.data.data;
  }
});

//subscribe to firebase notification
export const subscribeFirebaseNotification = createAsyncThunk(
  "app/subscribeFirebaseNotification",
  async (data, extra) => {
    const res = await http.post(`/notification/subscribe_topic/`, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    if (res.data.status === "success") {
      return res.data;
    }
  }
);

//unsubscribe to firebase notification
export const unsubscribeFirebaseNotification = createAsyncThunk(
  "app/unsubscribeFirebaseNotification",
  async (data, extra) => {
    const res = await http.post(`/notification/unsubscribe_topic/`, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    if (res.data.status === "success") {
      return res.data;
    }
  }
);

//Updates Sales Target Value
// Endpoint: PUT /user_profile/backend/update-sales-target/
export const updateSalesTarget = createAsyncThunk("app/updateSalesTarget", async (data, extra) => {
  const res = await http.put("/user_profile/backend/update-sales-target/", data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  if (res.data.status === "success") {
    return res.data.data;
  }
});

//print settings and print options
export const fetchPrintSettings = createAsyncThunk("app/fetchPrintSettings", async (data, extra) => {
  const res = await http.get(`/profile_settings/`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  if (res.data.status === "success") {
    return res.data.data;
  }
});

export const createPrintSettings = createAsyncThunk("app/createPrintSettings", async (data, extra) => {
  const res = await http.post(`/profile_settings/`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  if (res.data.status === "success") {
    return res.data;
  }
});

export const updatePrintSettings = createAsyncThunk("app/updatePrintSettings", async (data, extra) => {
  const res = await http.put(`/profile_settings/`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  if (res.data.status === "success") {
    return res.data;
  }
});

export const deletePrintSettings = createAsyncThunk("app/deletePrintSettings", async (data, extra) => {
  const res = await http.delete(`/profile_settings/`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });

  if (res?.data) {
    return res.data;
  }
});

export const appSlice = createSlice({
  name: "app",
  initialState: {
    dashboard: {
      top_selling_items: [],
      sales_graph: {
        current_month_data: [],
        previous_month_data: [],
        x_labels: [],
      },
      profit_margin: 0,
      absolute_profit_margin: 0,
      total_sales_price: 0,
      total_stock_price: 0,
      showedMainLoading: false,
    },
    showWaitLoader: false,
    showMainLoader: false,
    showInvoiceLoader: false,
    // alert: { showAlert: false, message: "", type: "success" },
    sidebarInvoice: false,
    global_search: { products: [], customers: [], vendors: [] },
    global_search_show: false,
    printSettings: {
      printer_type: "A4",
      paper_width_mm: 210,
      paper_height_mm: 297,
      show_deal_price: false,
      show_batch_number: false,
      show_batch_expiry: false,
      show_mrp_discount: false,
      header_text: "",
      footer_text: "",
      show_logo: true,
      show_gst: true,
    },
    productInventoryType: "Bill Of Material",
  },
  reducers: {
    // toggleAlert: (state, action) => {
    //   return { ...state, alert: action.payload };
    // },
    // reset: (state) => {
    //   return { ...state, alert: { showAlert: false, message: "", type: "success" } };
    // },
    sidebarInvoice: (state, action) => {
      return { ...state, sidebarInvoice: action.payload };
    },
    toggleGlobalSearch: (state, action) => {
      return { ...state, global_search_show: !state.global_search_show };
    },
    setShowWaitLoader: (state, action) => {
      return { ...state, showWaitLoader: action.payload };
    },
    setShowMainLoader: (state, action) => {
      if (!state.dashboard.showedMainLoading) {
        return { ...state, showMainLoader: action.payload };
      }
    },
    setShowInvoiceLoader: (state, action) => {
      return { ...state, showInvoiceLoader: action.payload };
    },
    flushPrintSettings: (state, action) => {
      return {
        ...state,
        printSettings: {
          printer_type: "A4",
          paper_width_mm: 210,
          paper_height_mm: 297,
          show_deal_price: false,
          show_batch_number: false,
          show_batch_expiry: false,
          show_mrp_discount: false,
          header_text: "",
          footer_text: "",
          show_logo: true,
          show_gst: true,
        },
      };
    },
    setProductInventoryType: (state, action) => {
      return { ...state, productInventoryType: action.payload };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchDashboard.fulfilled, (state, action) => {
      return { ...state, dashboard: { ...action.payload, showedMainLoading: true } };
    });
    builder.addCase(fetchGlobalSearchData.fulfilled, (state, action) => {
      const { products, customers, vendors } = action.payload;
      return {
        ...state,
        global_search: {
          products: products || [],
          customers: customers || [],
          vendors: vendors || [],
        },
      };
    });
    builder.addCase(fetchPrintSettings.fulfilled, (state, action) => {
      return { ...state, printSettings: action.payload };
    });
  },
});

export default appSlice.reducer;
export const {
  sidebarInvoice,
  toggleGlobalSearch,
  setShowWaitLoader,
  setShowMainLoader,
  setShowInvoiceLoader,
  flushPrintSettings,
  setProductInventoryType,
} = appSlice.actions;
